const E_OK = 0;
const E_ACCOUNT_NOT_EXISTS = 1;
const E_FAILED_TO_ADD_ACCOUNT = 2;
const E_FAILED_APICALL_TO_APIBK_GETTOKEN = 3;
const E_FAILED_APICALL_TO_APIBK_BINDUSER = 4;
const E_FAILED_APICALL_TO_APIBK_UNBINDUSER = 5;
// const E_FAILED_APICALL_TO_APIBK_TRANC = 6;
const E_FAILED_APICALL_TO_APIBK_WITHDRAW = 7;
const E_COIN_NOT_ENOUGH = 8;
const E_WALLET_NOT_BINDED = 9;
const E_INVALID_SESSION = 10;
const E_BALANCE_NOT_ENOUGH = 11;
const E_LOGINNAME_IS_DIFFERENT = 12;
const E_BINDNAME_IS_DIFFERENT = 13;
const E_GET_ORDERS_FAILED = 14;
const E_INVALID_COIN = 15;
const E_OTC_FAILED = 16;
const E_MODEL_GAME_ORDER_SET_FAILED = 17;
const E_SYSTEM_FAILURE = 99999;

module.exports = {
    E_OK,
    E_ACCOUNT_NOT_EXISTS,
    E_FAILED_TO_ADD_ACCOUNT,
    E_FAILED_APICALL_TO_APIBK_GETTOKEN,
    E_FAILED_APICALL_TO_APIBK_BINDUSER,
    E_FAILED_APICALL_TO_APIBK_UNBINDUSER,
    // E_FAILED_APICALL_TO_APIBK_TRANC,
    E_FAILED_APICALL_TO_APIBK_WITHDRAW,
    E_COIN_NOT_ENOUGH,
    E_WALLET_NOT_BINDED,
    E_INVALID_SESSION,
    E_BALANCE_NOT_ENOUGH,
    E_LOGINNAME_IS_DIFFERENT,
    E_BINDNAME_IS_DIFFERENT,
    E_GET_ORDERS_FAILED,
    E_INVALID_COIN,
    E_OTC_FAILED,
    E_MODEL_GAME_ORDER_SET_FAILED,

    E_SYSTEM_FAILURE,
};